export default "__VITE_ASSET__gZw5_PhC__"